import { IS_PRODUCTION_ENV } from "@src/config";
import { SwapperConfig } from "@src/models";

const swapperConfig: SwapperConfig = {
  apiUrl: IS_PRODUCTION_ENV
    ? "https://swapper.finance/api/beta"
    : "https://testnet.swapper.finance/api/beta",
  // apiUrl: "http://127.0.0.1:5002/swapper-429608/europe-west1/app/api/beta",
  localCss: false,
};

let swapperConfigLocal = {};
try {
  // eslint-disable-next-line
  swapperConfigLocal = require("./swapper.config.local").default;
} catch {
  // There's no local config, nothing to override.
}

export default {
  ...swapperConfig,
  ...swapperConfigLocal,
};
